module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQBAMAAADt3eJSAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURUdwTABU3ABU1wBV3QBV3ABQ1ABV3ABU2wBV3ABV3QBV2gBU2gBV3FcahTMAAAAMdFJOUwCQIN+iEM5Afu8wW1RjwcUAAACESURBVAjXY2BgKLQ55sQABIFngECUgYE1Z0YBl8+xAAbGwwoMDEw2Agw6h0DymscZfBw0z5w5zXGQIWeBz5kzx9gPM5xhsBFgAVFnGFae6DEC8Qu4z5zZwHWMQaaBoecEA8sRhppJDCxgQ4AGsgaADGTNObKAvRNoBdxSBgaVnMPiDAwAjjgsrarzlwwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image1.png
// module id = T//I
// module chunks = 1